
let production_id = null;
let production_from = null;

window.production_visuals = function(result) {

    if (window.target_artwork) {
        let row  = window.target_artwork.parents('tr');
        if (row) {
            row.find('.status-artroom-badge').html(result.badge);
            row.find('.status-artroom-select').html(result.select);
        }
    }

    $('.production-bar-' + result.id).replaceWith(result.bar);
    if (result.box && $('#production-brief')) {
        if ($('#production-brief').hasClass('col-md-12')) {
            $('#production-brief').removeClass('col-md-12').addClass('col-md-6');
            $('#production-brief').parent().prepend(`<div class="col-md-6" id="production-status">${result.box}</div>`);
        } else {
            $('#production-status').html(result.box);
        }
    }

    window.target_artwork = null;
};

// Opens the job brief modal to send to production
window.sendProduction = function(id, from) {

    $('#sendProductionModal .modal-cover').hide();

    production_id = id;
    production_from = from;

    $.ajax({
        url: '/artroom/brief/' + production_id,
        type: 'get',

        dataType: 'json',
        data: {},
        success: function (result) {

            $('#sendProductionModal .alert').remove();

            $('#sendProductionModal .modal-title').html(result.title);
            $('#sendProductionModal .modal-body').html(result.body);

            $('#sendProductionModal .modal-body').prepend(`<input type="hidden" name="from" value="${production_from}" />`);


            tinymce.init({
                selector: '#jobBrief',
                height: $('#contractNotes').data('height') ?? 150,
                menubar: false,
                statusbar: false,
                default_text_color: 'red',
                plugins: [
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                ],
                toolbar1: 'undo redo | insert | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link | codesample',
                content_css: []
            });

            if (false) {
                ///window.dropZone.removeAllFiles(true);
            } else {
                const dropZone = new Dropzone("#briefAttachments", {
                    url: "/documents/upload/supplied/" + production_id,
                    dictResponseError: 'Error uploading file!',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                    }
                });

                dropZone.on("addedfile", file => {
                    $('#line-meta-files table tbody').append(`<tr>
                            <td>${file.name}</td>
                            <td>${file.size}</td>
                        </tr>`)
                });
            }

            $('#sendProductionModal').modal({
                keyboard: false,
                backdrop: 'static'
            }).modal('show')

            feather.replace();
        }
    });
}

// Form handler when uploading to production
window.createArtwork = function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    tinymce.triggerSave();

    $('#sendProductionModal .modal-cover').show();

    let $data = $("#sendProductionModal form").serialize();

    //$('#newXeroContact button, #newXeroContact select, #newXeroContact input').prop('disabled', true);
    //$('#newXeroContact').addClass('ajaxSaving');

    $.ajax({
        url: "/artroom/create",
        type: 'post',
        dataType: 'json',
        data: $data,
        success: function (result) {

            $('meta[name="csrf-token"]').attr('content', result.token);
            //$('#newXeroContact').removeClass('ajaxSaving');

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': result.token
                }
            });

            // Re-enable all the buttons //
            //$('#newXeroContact button, #newXeroContact select, #newXeroContact input').prop('disabled', false);

            // Now we need to filter the errors to make sure its all good //
            if (result.status === 'success') {

                $('#sendProductionModal').modal('hide');

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });

                Toast.fire({
                    icon: 'success',
                    title: 'Job has been successfully delivered to the Artroom.'
                })

                // Update the table if its an so-sender
                let parent = $(`.send-to-production[data-item="${production_id}"]`).parent();
                if (result.ui) {
                    parent.parent().find('.art-status').html(result.art_status);
                    parent.replaceWith(result.ui)
                }

                $('#sendProductionModal .modal-cover').hide();

                production_id = null;
                production_from = null;

            } else {

                alert(result.message);
                $('#sendProductionModal .modal-cover').hide();
            }

        },
        error: function (xhr, status, error) {
            // This will be general errors //

            $('#sendProductionModal .modal-cover').hide();
        }
    });
};

//Load repeat artwork modal
window.getRepeat = function () {

    $('#repeatArtworkModal .modal-cover').show();
    $('#repeatArtworkModal').modal('show');

    $.ajax({
        url: '/artroom/repeat/' + production_id,
        type: 'get',

        dataType: 'json',
        data: {},
        success: function (result) {

            $('#repeatArtworkModal .modal-title').html(result.title);
            $('#repeatArtworkModal .modal-body').html(result.body);

            $('#repeatArtworkModal .modal-cover').hide();

            feather.replace();
        }
    });
};

window.target_artwork = null;
window.loadProductionModal = function(id, status, elem) {

    $('#updateProductionModal .modal-cover').hide();

    window.target_artwork = elem;

    $.ajax({
        url: '/artroom/status/' + id + '/' + status,
        type: 'get',

        dataType: 'json',
        data: {},
        success: function (result) {

            if (result.status === 'success') {
                // No modal needed, just update the needfull
                production_visuals(result);

            } else if (result.status === 'modal') {

                $('#updateProductionModal .alert').remove();

                $('#updateProductionModal .modal-title').html(result.title);
                $('#updateProductionModal .modal-body').html(result.body);

                tinymce.init({
                    selector: '#jobBrief',
                    height: $('#contractNotes').data('height') ?? 150,
                    menubar: false,
                    statusbar: false,
                    default_text_color: 'red',
                    plugins: [
                        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                        'searchreplace wordcount visualblocks visualchars code fullscreen',
                    ],
                    toolbar1: 'undo redo | insert | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link | codesample',
                    content_css: []
                });

                $('#updateProductionModal').modal('show')

                feather.replace();
            } else if (result.status === 'error') {

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000,
                    timerProgressBar: true,
                });

                Toast.fire({
                    icon: 'error',
                    title: result.message
                })

                if (elem) {
                    elem.val(elem.data('default'));
                }
            }
        }
    });
};

window.updateProduction = function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    tinymce.triggerSave();

    $('#updateProductionModal .modal-cover').show();
    let $data = $("#updateProductionModal form").serialize();

    $.ajax({
        url: "/artroom/status/confirm",
        type: 'post',
        dataType: 'json',
        data: $data,
        success: function (result) {

            $('meta[name="csrf-token"]').attr('content', result.token);

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': result.token
                }
            });

            console.log(result);

            if (result.status === 'success') {

                $('#updateProductionModal').modal('hide');
                production_visuals(result);

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });

                Toast.fire({
                    icon: 'success',
                    title: result.message
                })

                $('#updateProductionModal .modal-cover').hide();

            } else {

                alert(result.message);
                $('#updateProductionModal .modal-cover').hide();
            }

        },
        error: function (xhr, status, error) {
            // This will be general errors //

            $('#updateProductionModal .modal-cover').hide();
        }
    });
};

window.handleProofing = function(id, status) {

    $('#updateProductionModal .modal-cover').hide();

    $.ajax({
        url: '/artroom/proofing/' + id + '/' + status,
        type: 'get',

        dataType: 'json',
        data: {},
        success: function (result) {

            if (result.status === 'success') {

                production_visuals(result);

            } else if (result.status === 'modal') {

                $('#updateProductionModal .alert').remove();

                $('#updateProductionModal .modal-title').html(result.title);
                $('#updateProductionModal .modal-body').html(result.body);

                tinymce.init({
                    selector: '#jobBrief',
                    height: $('#contractNotes').data('height') ?? 150,
                    menubar: false,
                    statusbar: false,
                    default_text_color: 'red',
                    plugins: [
                        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                        'searchreplace wordcount visualblocks visualchars code fullscreen',
                    ],
                    toolbar1: 'undo redo | insert | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link | codesample',
                    content_css: []
                });

                $('#updateProductionModal').modal('show')

                feather.replace();
            } else if (result.status === 'error') {

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000,
                    timerProgressBar: true,
                });

                Toast.fire({
                    icon: 'error',
                    title: result.message
                })
            }
        }
    });

};

window.key_timer = null;
window.ajax_timer = null;

window.updateArtroomRecord = function(row) {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    if (window.ajax_timer !== null) {
        window.ajax_timer.abort();
        window.ajax_timer = null;
    }

    const id = row.data('row');

    let data = {
        'page' : row.find('[name="page"]').val(),
        'placement' : row.find('[name="placement"]').val(),
        'placed' : row.find('[name="placed"]').is(':checked') ? 1 : 0
    };

    window.ajax_timer = $.ajax({
        url: "/artroom/row/" + id,
        type: 'post',
        dataType: 'json',
        data: data,
        success: function (result) {

            $('meta[name="csrf-token"]').attr('content', result.token);

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': result.token
                }
            });

        },
        error: function (xhr, status, error) {

        }
    });

};

$(function () {

    $('body').on('change', '.status-artroom-save', function() {
        let row = $(this).parents('tr');
        updateArtroomRecord(row);
    });

    $('body').on('keyup', '.status-artroom-save', function() {
        let row = $(this).parents('tr');

        if (window.key_timer !== null) {
            clearTimeout(window.key_timer);
            window.key_timer = null;
        }

        window.key_timer = setTimeout(function() {
            updateArtroomRecord(row);
        }, 750);

    });

    $('body').on('hidden.bs.modal', '#sendProductionModal, #updateProductionModal', function() {
        tinymce.remove('#jobBrief');
    });

    $('body').on('hidden.bs.modal', '#repeatArtworkModal', function() {
        $('#repeatArtworkModal .modal-body').html('');
    });

    $('body').on('change', 'select.update-artwork-status', function() {
        let opt = $(this).find('option:selected');
        loadProductionModal(opt.data('artwork'), opt.data('production'), $(this));
    })

    $('body').on('click', '.update-production', function() {
        updateProduction();
    });

    $('body').on('click', 'button.btn-light[data-production]', function() {
        loadProductionModal($(this).data('artwork'), $(this).data('production'));
    })

    $('body').on('click', '.proof-handler', function() {
        handleProofing($(this).data('id'), $(this).hasClass('btn-success') ? 'approved' : 'declined');
    });

    $('body').on('click', '.send-to-client', function() {
        handleProofing($(this).data('id'), 'client');
    });

    $('body').on('click', '.artwork-create', function() {
        // put in some validation eventually
        if ($('select[name="artwork"]').val() === 'repeat') {
            getRepeat();
        } else {
            createArtwork();
        }
    });

    $('body').on('click', '.view-selected', function() {
        let pdf = $(this).prev();
        if (pdf.val() !== '') {
            let option = $(this).prev().find('option:selected')
            document.getElementById('zissou-click').setAttribute('href', option.data('open'));
            document.getElementById('zissou-click').click();
        } else {
            alert('You gotta pick a PDF...')
        }
    });

    $('body').on('click', '.repeat-select', function() {

        let pdf = $(this).parent('.input-group').find('select.form-select option:selected');

        if (pdf.val() !== '') {

            console.log(pdf);

            $('#sendProductionModal input[name="is_repeat"]').val(1);
            $('#sendProductionModal input[name="repeat[path]"]').val(pdf.data('path'));
            $('#sendProductionModal input[name="repeat[pdf]"]').val(pdf.attr('value'));

            $('#repeatArtworkModal').modal('hide');

            // Need to submit the form now
            createArtwork();
        } else {
            alert('You gotta pick a PDF...')
        }
    });
});